// extracted by mini-css-extract-plugin
export default {"controls":"controls---wwETF","control":"control---lt3eN","notice":"notice---_Uamm","noPrint":"noPrint---XAZVj"};